import { VerifiedSkill, VerifiedSkillCategory } from 'src/models/resume/resumeVerifiedSkills.types';

export const getAppropriateSkill = (skill: VerifiedSkill, id: number | string): boolean => {
    return skill.id === id && skill.category === VerifiedSkillCategory.Skill;
};
